import { CheckCircleIcon } from '@heroicons/react/24/outline';

/** Completion describes validation, not saving, clinical safety, or approval. */
export function CompletionBadge({ complete, required, id }: { complete: boolean; required: boolean; id?: string }) {
  return <span id={id} className="ml-2 inline-flex" aria-live="polite" aria-atomic="true">
    {complete ? <strong className="wellness-completion"><CheckCircleIcon className="h-4 w-4 shrink-0" aria-hidden /> Complete</strong>
      : required ? <strong className="text-alert-700">Required</strong> : null}
  </span>;
}
